import { SET_SUPER_ADMIN, SET_CURSOR_X } from './types.js'

export default {
  [SET_CURSOR_X](state, cursor_x) {
    state.cursor_x = cursor_x
  },
  [SET_SUPER_ADMIN](state, is_super_admin) {
    state.is_super_admin = is_super_admin
  },
}
